import React, { useState } from 'react';
import heartFrame from '../assets/heart frame.png';
import bookFrame from '../assets/book frame.png';
import peopleFrame from '../assets/people frame.png';
import colorPalette from '../assets/color palette.png';
import vennDiagram from '../assets/venn diagram.png';
import vennDiagramBoxes from '../assets/venn diagram boxes.png';
import Footer from './Footer';

const IkigaiAssessment = () => {
  const [activeView, setActiveView] = useState('matrix'); // 'matrix' or 'venn'
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="min-h-screen w-full overflow-x-hidden bg-gradient-to-br from-[#EFF6FF] via-white to-[#F9FAFB] flex flex-col" style={{ fontFamily: 'Roboto Slab, serif' }}>
      {/* Navbar */}
      <nav className="w-full flex items-center justify-between px-4 sm:px-6 lg:px-8 py-3 border-b bg-white/80 relative">
        <div className="font-extrabold text-lg text-black tracking-wide">LOGO</div>
        <div className="hidden sm:flex gap-4 lg:gap-8 text-sm">
          <a href="#" className="text-gray-700 hover:underline">Home</a>
          <a href="#" className="text-gray-700 hover:underline">About</a>
          <a href="#" className="text-gray-700 hover:underline">FAQs</a>
          <button className="ml-4 px-4 py-1 bg-gradient-to-r from-[#ff512f] to-[#dd2476] text-white font-bold rounded text-sm">Get Started</button>
        </div>
        {/* Mobile menu button */}
        <div className="sm:hidden">
          <button
            onClick={toggleMenu}
            className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-[#9C27B0] hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#9C27B0] transition-colors duration-200"
            aria-expanded="false"
          >
            <span className="sr-only">Open main menu</span>
            {/* Hamburger icon */}
            <svg
              className={`${isMenuOpen ? 'hidden' : 'block'} h-6 w-6`}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            {/* Close icon */}
            <svg
              className={`${isMenuOpen ? 'block' : 'hidden'} h-6 w-6`}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </nav>

      {/* Mobile Navigation Menu */}
      <div className={`${isMenuOpen ? 'block' : 'hidden'} sm:hidden absolute top-full left-0 right-0 bg-white border-b border-gray-200 shadow-lg z-50`}>
        <div className="px-4 py-2 space-y-1">
          <a 
            href="#" 
            className="block px-3 py-2 text-gray-700 hover:text-[#9C27B0] hover:bg-gray-50 rounded-md text-base transition-colors duration-200"
            onClick={() => setIsMenuOpen(false)}
          >
            Home
          </a>
          <a 
            href="#" 
            className="block px-3 py-2 text-gray-700 hover:text-[#9C27B0] hover:bg-gray-50 rounded-md text-base transition-colors duration-200"
            onClick={() => setIsMenuOpen(false)}
          >
            About
          </a>
          <a 
            href="#" 
            className="block px-3 py-2 text-gray-700 hover:text-[#9C27B0] hover:bg-gray-50 rounded-md text-base transition-colors duration-200"
            onClick={() => setIsMenuOpen(false)}
          >
            FAQs
          </a>
          <button
            className="w-full mt-2 px-4 py-2 bg-gradient-to-r from-[#ff512f] to-[#dd2476] text-white font-bold rounded text-sm"
            onClick={() => setIsMenuOpen(false)}
          >
            Get Started
          </button>
        </div>
      </div>
      
      {/* Main Content */}
      <div className="flex-1 flex flex-col items-center px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-7xl mx-auto">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center mt-8 sm:mt-12 mb-4">Your IKIGAI Discovery</h1>
          <p className="text-center text-gray-600 mb-8 sm:mb-12 max-w-2xl mx-auto text-sm sm:text-base">Explore your purpose through different perspectives</p>
          
        {/* Button Group */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 mb-12 sm:mb-16">
            <button 
              className={`w-full sm:w-auto px-6 sm:px-8 py-2 rounded-full font-semibold shadow-md border border-purple-200 transition-all text-sm sm:text-base ${
                activeView === 'matrix' 
                  ? 'text-white bg-gradient-to-r from-[#ff5e62] to-[#8f44fd]' 
                  : 'bg-white text-gray-700'
              }`}
              onClick={() => setActiveView('matrix')}
            >
              Result Matrix
            </button>
            <button 
              className={`w-full sm:w-auto px-6 sm:px-8 py-2 rounded-full font-semibold shadow-md border border-purple-200 transition-all text-sm sm:text-base ${
                activeView === 'venn' 
                  ? 'text-white bg-gradient-to-r from-[#ff5e62] to-[#8f44fd]' 
                  : 'bg-white text-gray-700'
              }`}
              onClick={() => setActiveView('venn')}
            >
              Venn Diagram
            </button>
          </div>
          
                   {activeView === 'matrix' ? (
            <>
              <h2 className="text-xl sm:text-2xl font-bold text-center mb-4">Your IKIGAI Map</h2>
              <p className="text-center text-gray-600 mb-8 sm:mb-12 text-sm sm:text-base">Discover the intersection of your purpose</p>
              
              {/* Four Cards Grid */}
              <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-20 mb-8 sm:mb-10 max-w-6xl w-full">
           {/* Connecting Lines */}
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none hidden lg:block">
             <div className="w-full h-full relative">
               {/* Horizontal line */}
               <div className="absolute top-1/2 left-0 right-0 h-px bg-blue-300 border-dashed border-blue-300 transform -translate-y-1/2"></div>
               {/* Vertical line */}
               <div className="absolute left-1/2 top-0 bottom-0 w-px bg-blue-300 border-dashed border-blue-300 transform -translate-x-1/2"></div>
               {/* Center intersection */}
               <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-blue-300 rounded-full"></div>
             </div>
           </div>
           
                       {/* Top Left - What You Love */}
                <div className="rounded-xl bg-[#FFE5E1] p-4 sm:p-6 flex flex-col shadow-md relative z-10">
              <div className="flex items-start mb-3">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-pink-500 rounded-lg flex items-center justify-center mr-3 shadow-sm">
                      <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                  </svg>
                </div>
                <div>
                      <h3 className="font-bold text-base sm:text-lg text-gray-800">What You Love</h3>
                      <p className="text-xs sm:text-sm text-gray-600">Your passions and interests</p>
                </div>
              </div>
                  <div className="text-gray-700 text-xs sm:text-sm">
                Reading; Business & Economics; Sharing personal stories; Performance stages; Intellectual puzzles
              </div>
            </div>
           
                                               {/* Top Right - What You Are Good At */}
                <div className="rounded-xl bg-[#F3E5F5] p-4 sm:p-6 flex flex-col shadow-md relative z-10">
               <div className="flex items-start mb-3">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-purple-500 rounded-xl flex items-center justify-center mr-3 shadow-sm">
                      <svg width="20" height="20" className="sm:w-6 sm:h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                       <path d="M9.93743 15.5002C9.84815 15.1542 9.66777 14.8384 9.41505 14.5856C9.16232 14.3329 8.8465 14.1525 8.50043 14.0632L2.36543 12.4812C2.26076 12.4515 2.16864 12.3885 2.10304 12.3017C2.03744 12.2149 2.00195 12.1091 2.00195 12.0002C2.00195 11.8914 2.03744 11.7856 2.10304 11.6988C2.16864 11.612 2.26076 11.549 2.36543 11.5192L8.50043 9.93625C8.84638 9.84706 9.16212 9.66682 9.41483 9.41429C9.66754 9.16175 9.84799 8.84614 9.93743 8.50025L11.5194 2.36525C11.5488 2.26017 11.6118 2.16759 11.6987 2.10164C11.7857 2.0357 11.8918 2 12.0009 2C12.11 2 12.2162 2.0357 12.3031 2.10164C12.39 2.16759 12.453 2.26017 12.4824 2.36525L14.0634 8.50025C14.1527 8.84632 14.3331 9.16215 14.5858 9.41487C14.8385 9.66759 15.1544 9.84797 15.5004 9.93725L21.6354 11.5182C21.7409 11.5473 21.834 11.6103 21.9003 11.6973C21.9666 11.7844 22.0025 11.8908 22.0025 12.0002C22.0025 12.1097 21.9666 12.2161 21.9003 12.3032C21.834 12.3902 21.7409 12.4531 21.6354 12.4822L15.5004 14.0632C15.1544 14.1525 14.8385 14.3329 14.5858 14.5856C14.3331 14.8384 14.1527 15.1542 14.0634 15.5002L12.4814 21.6353C12.452 21.7403 12.389 21.8329 12.3021 21.8989C12.2152 21.9648 12.109 22.0005 11.9999 22.0005C11.8908 22.0005 11.7847 21.9648 11.6977 21.8989C11.6108 21.8329 11.5478 21.7403 11.5184 21.6353L9.93743 15.5002Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                       <path d="M20 3V7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                       <path d="M22 5H18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                       <path d="M4 17V19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                       <path d="M5 18H3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                     </svg>
                  </div>
                 <div>
                      <h3 className="font-bold text-base sm:text-lg text-gray-800">What You Are Good At</h3>
                      <p className="text-xs sm:text-sm text-gray-600">Your skills and talents</p>
                 </div>
               </div>
                  <div className="text-gray-700 text-xs sm:text-sm">
                 Building relationships; Public speaking; Staying calm under pressure; The implementer; Great at explaining things
               </div>
             </div>
           
           {/* Bottom Left - What The World Needs */}
                <div className="rounded-xl bg-[#E8F5E8] p-4 sm:p-6 flex flex-col shadow-md relative z-10">
             <div className="flex items-center mb-3">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-green-400 rounded-full flex items-center justify-center mr-3">
                      <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
                 </svg>
               </div>
               <div>
                      <h3 className="font-bold text-base sm:text-lg text-black">What The World Needs</h3>
                      <p className="text-xs sm:text-sm text-gray-600">Problems you can solve</p>
               </div>
             </div>
                  <div className="text-gray-700 text-xs sm:text-sm">
               Poverty & inequality, Arts & culture preservation; Improving health and wellness; Communication barriers; Creating beautiful experiences
             </div>
           </div>
           
           {/* Bottom Right - What You Can Be Paid For */}
                <div className="rounded-xl bg-[#E3F2FD] p-4 sm:p-6 flex flex-col shadow-md relative z-10">
             <div className="flex items-center mb-3">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-400 rounded-full flex items-center justify-center mr-3">
                      <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-1.447-.894L15 4m0 13V4m0 0L9 7"></path>
                 </svg>
               </div>
               <div>
                      <h3 className="font-bold text-base sm:text-lg text-black">What You Can Be Paid For</h3>
                      <p className="text-xs sm:text-sm text-gray-600">Your economic opportunities</p>
               </div>
             </div>
                  <div className="text-gray-700 text-xs sm:text-sm">
               Consulting & advice; Problem-solving, Creative industries; Creating art or media; Learning experiences
             </div>
           </div>
         </div>
              
        {/* Large Summary Card */}
              <div className="rounded-2xl bg-pink-100 p-4 sm:p-8 shadow-lg max-w-4xl w-full mb-6 sm:mb-8">
          <div className="flex items-center mb-3">
                  <div className="w-4 h-4 sm:w-6 sm:h-6 bg-pink-400 rounded-full mr-3"></div>
                  <span className="font-semibold text-lg sm:text-xl text-gray-800">Your IKIGAI Result!</span>
          </div>
                <div className="text-gray-700 text-xs sm:text-sm mb-4">
            The center intersection represents your life's purpose - where all four elements come together.
          </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-xs sm:text-sm">
                  <div className="bg-white/50 rounded-lg p-2 sm:p-3">
              <span className="font-semibold text-purple-600">Passion:</span> Meaningful, Psychology
            </div>
                  <div className="bg-white/50 rounded-lg p-2 sm:p-3">
              <span className="font-semibold text-pink-600">Profession:</span> Building & Innovation
            </div>
                  <div className="bg-white/50 rounded-lg p-2 sm:p-3">
              <span className="font-semibold text-yellow-600">Vocation:</span> Social justice, Scientific research
            </div>
                  <div className="bg-white/50 rounded-lg p-2 sm:p-3">
              <span className="font-semibold text-blue-600">Mission:</span> Creative problem-solving, Psychology
            </div>
          </div>
        </div>
              
        {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mb-8 sm:mb-10">
                <button className="w-full sm:w-auto px-6 py-2 bg-pink-500 text-white rounded font-semibold shadow hover:bg-pink-600 transition text-sm sm:text-base">Start Over</button>
                <button className="w-full sm:w-auto px-6 py-2 bg-white border border-gray-300 text-gray-700 rounded font-semibold shadow transition text-sm sm:text-base">Try Johari Window Test</button>
        </div>
      </>
    ) : (
      <>
              <h2 className="text-xl sm:text-2xl font-bold text-center mb-4">IKIGAI Venn Diagram</h2>
              <p className="text-center text-gray-600 mb-8 sm:mb-12 text-sm sm:text-base">Visual representation of your life's purpose with your values</p>
              
        {/* Venn Diagram Image */}
              <div className="flex justify-center mb-8 sm:mb-10">
                <div className="max-w-4xl w-full bg-gray-100 rounded-lg shadow-lg p-4 sm:p-8">
            <img 
              src={vennDiagram} 
              alt="IKIGAI Venn Diagram" 
              className="w-full h-auto"
              style={{ objectFit: 'contain' }}
              onError={(e) => {
                console.error('Error loading Venn diagram image');
                e.target.style.display = 'none';
                e.target.parentElement.innerHTML = '<div class="text-center text-gray-500 py-8">Venn Diagram Image</div>';
              }}
            />
          </div>
        </div>
              
                {/* Venn Diagram Boxes Design */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 mb-8 sm:mb-10 max-w-5xl w-full">
          {/* What You Love */}
          <div 
                  className="bg-white shadow-lg w-full"
            style={{ 
                    minHeight: '280px',
              borderRadius: '16px',
              border: '2px solid #E6E6FA',
                    padding: '16px',
              opacity: 1
            }}
          >
            <div className="flex items-center mb-4">
                    <div className="w-6 h-6 sm:w-8 sm:h-8 bg-purple-600 rounded-full flex items-center justify-center mr-3">
                      <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                </svg>
              </div>
                    <h3 className="font-bold text-sm sm:text-base text-purple-800">What You LOVE</h3>
            </div>
            <div className="space-y-2">
                    <div className="px-2 sm:px-3 py-2 rounded text-gray-800 text-xs sm:text-sm" style={{ backgroundColor: '#F3E5F5' }}>Drawing/Painting</div>
                    <div className="px-2 sm:px-3 py-2 rounded text-gray-800 text-xs sm:text-sm" style={{ backgroundColor: '#F3E5F5' }}>Psychology & Human Behavior</div>
                    <div className="px-2 sm:px-3 py-2 rounded text-gray-800 text-xs sm:text-sm" style={{ backgroundColor: '#F3E5F5' }}>Debating current events</div>
                    <div className="px-2 sm:px-3 py-2 rounded text-gray-800 text-xs sm:text-sm" style={{ backgroundColor: '#F3E5F5' }}>Performance stages</div>
                    <div className="px-2 sm:px-3 py-2 rounded text-gray-800 text-xs sm:text-sm" style={{ backgroundColor: '#F3E5F5' }}>Intellectual puzzles</div>
            </div>
          </div>
          
          {/* What You're Good At */}
                <div className="rounded-2xl bg-white p-4 sm:p-8 shadow-lg border border-gray-100">
            <div className="flex items-center mb-4">
                    <div className="w-8 h-8 sm:w-10 sm:h-10 bg-pink-500 rounded-full flex items-center justify-center mr-3 sm:mr-4">
                      <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
              </div>
                    <h3 className="font-bold text-base sm:text-lg text-gray-800">What You're GOOD AT</h3>
            </div>
                  <ul className="text-gray-700 text-xs sm:text-sm space-y-2">
              <li>• Building relationships</li>
              <li>• Innovation</li>
              <li>• Creative problem-solving</li>
              <li>• The implementer</li>
              <li>• Inspiring and motivating</li>
            </ul>
          </div>
          
          {/* What World Needs */}
                <div className="rounded-2xl bg-white p-4 sm:p-8 shadow-lg border border-gray-100">
            <div className="flex items-center mb-4">
                    <div className="w-8 h-8 sm:w-10 sm:h-10 bg-orange-500 rounded-full flex items-center justify-center mr-3 sm:mr-4">
                      <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
                    <h3 className="font-bold text-base sm:text-lg text-gray-800">What World Needs</h3>
            </div>
                  <ul className="text-gray-700 text-xs sm:text-sm space-y-2">
              <li>• Social justice</li>
              <li>• Scientific research</li>
              <li>• Fostering innovation</li>
              <li>• Mental health stigma</li>
              <li>• Inspiring positive change</li>
            </ul>
          </div>
          
          {/* What You Can Be Paid For */}
                <div className="rounded-2xl bg-white p-4 sm:p-8 shadow-lg border border-gray-100">
            <div className="flex items-center mb-4">
                    <div className="w-8 h-8 sm:w-10 sm:h-10 bg-blue-500 rounded-full flex items-center justify-center mr-3 sm:mr-4">
                      <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"></path>
                </svg>
              </div>
                    <h3 className="font-bold text-base sm:text-lg text-gray-800">What You Can Be Paid For</h3>
            </div>
                  <ul className="text-gray-700 text-xs sm:text-sm space-y-2">
              <li>• Research & analysis</li>
              <li>• Communication skills</li>
              <li>• Media & communications</li>
              <li>• Health and wellness coaching</li>
              <li>• Positive relationships</li>
            </ul>
          </div>
        </div>
              
        {/* Large Summary Card */}
              <div className="rounded-2xl bg-[#FFE5E1] p-4 sm:p-8 shadow-lg max-w-3xl w-full mb-6 sm:mb-8">
          <div className="flex items-center mb-2">
                  <img src={heartFrame} alt="ikigai" className="w-5 h-5 sm:w-7 sm:h-7 mr-2" />
                  <span className="font-semibold text-lg sm:text-xl">Your IKIGAI</span>
          </div>
                <div className="text-gray-700 text-xs sm:text-sm mb-4">
            Your IKIGAI is the intersection of what you love (Reading, Business & Economics, Sharing personal stories, Performance impact, Intellectual pursuits), what you are good at (Building relationships, Public speaking, Solving case studies, The big-picture, Creative conceptualizing things), what the world needs (Poverty & inequality activism, Career presentation, Supporting health and wellness, Communication barriers, Creating heartfelt experiences), and what you can be paid for (Consulting, Coaching, Marketing analysis, Creative storytelling, Owning your own studio, Learning experiences). This unique combination represents your reason to help and your path to a fulfilling career.
          </div>
          <div className="flex gap-2 flex-wrap">
                  <span className="bg-pink-200 text-pink-800 px-2 sm:px-3 py-1 rounded-full text-xs font-semibold">Purpose: #love</span>
                  <span className="bg-blue-200 text-blue-800 px-2 sm:px-3 py-1 rounded-full text-xs font-semibold">Meaningful Work</span>
                  <span className="bg-green-200 text-green-800 px-2 sm:px-3 py-1 rounded-full text-xs font-semibold">Sustainable Path</span>
          </div>
        </div>
              
        {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mb-8 sm:mb-10">
                <button className="w-full sm:w-auto px-6 py-2 bg-pink-500 text-white rounded font-semibold shadow hover:bg-pink-600 transition text-sm sm:text-base">Start Over</button>
                <button className="w-full sm:w-auto px-6 py-2 bg-white border border-gray-300 text-gray-700 rounded font-semibold shadow transition text-sm sm:text-base">Try Johari Window Test</button>
        </div>
      </>
    )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default IkigaiAssessment; 